import { Component } from '@verndale/core';
import Menu from '../../components/Menu';

class GlobalFleetItem extends Component {
  setupDefaults() {
    this.dom = {
      $menu: this.$el.find('.service__menu')
    };
    new Menu(this.dom.$menu);
  }
}

export default GlobalFleetItem;
